// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__31fcv","clinicsSelect":"TableHeading_clinicsSelect__3zpX-"};